import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateTextStyle } from '../api';
import { TextStyleForm } from '../components';
import { TextStyleFormValues } from '../validations';

export const NewTextStylePage: FC = () => {
  const navigate = useNavigate();
  const { createTextStyleMutation } = useCreateTextStyle();

  const saveTextStyle = async (values: TextStyleFormValues) => {
    try {
      await createTextStyleMutation.mutateAsync({
        id: crypto.randomUUID(),
        name: values.name,
        content: values.content,
      });
      navigate(Routes.TextStyles, { replace: true });
      toast.success(`Text style "${values.name}" added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <TextStyleForm onSubmit={saveTextStyle}>
      <PageHeader
        title="New Text Style"
        asChildPage
        backPath={Routes.TextStyles}
        actions={[
          <Button
            key="create-text-style"
            type="submit"
            data-testid="create-text-style-button"
            isLoading={createTextStyleMutation.isPending}
            startIcon={<PlusSquareIcon />}
          >
            Create new text style
          </Button>,
        ]}
      />
    </TextStyleForm>
  );
};
